import { TypedDocumentNode } from '@apollo/client';
import { useMutation } from '@apollo/client/react';
import { Mutation } from 'graphql/generated/graphqlTypes';
import { GO_BACK_ONE_ONBOARDING_STEP } from 'graphql/mutations';
import { GET_CURRENT_TENANT } from 'graphql/queries';
import { useEffect } from 'react';
import { BaseHookProps } from 'v2/hooks/hooks.types';

// Typing the documents (instead of passing generics to the Apollo hooks) avoids the deprecated hook signatures.
const GO_BACK_ONE_ONBOARDING_STEP_TYPED: TypedDocumentNode<
  Pick<Mutation, 'goBackOneOnboardingStep'>,
  Record<string, never>
> = GO_BACK_ONE_ONBOARDING_STEP;

const useGoBackOneOnboardingStep = ({ handleFetchError }: BaseHookProps) => {
  const [goBackOneOnboardingStepMutation, { loading, error }] = useMutation(GO_BACK_ONE_ONBOARDING_STEP_TYPED, {
    refetchQueries: [{ query: GET_CURRENT_TENANT }],
    awaitRefetchQueries: true
  });

  useEffect(() => {
    if (error) {
      handleFetchError('Error while going back one step');
      console.error(error);
    }
  }, [error]);

  const goBackOneOnboardingStep = async () => {
    const result = await goBackOneOnboardingStepMutation();
    return result;
  };

  return {
    loading,
    goBackOneOnboardingStep
  };
};

export default useGoBackOneOnboardingStep;
